export const TEST_JOURNEY_TUTORIAL_VIDEO_ID = 'aDxdUJEsghA';

export const PROJECTS_START_TUTORIAL_VIDEO_ID = 'PiIJ8eSRldQ';
